export default __webpack_public_path__ + "static/media/Covered Straddle.93ec8916.svg";